export const OPOSICIONES_BASIC_PLAN = 'oposiciones_basic';

export const ALL_OPOS_AREA_IDS = [
  'secretaria',
  'c1',
  'c2',
  'iipp',
  'guardia_civil',
  'policia_nacional',
  'generico',
] as const;

const BASIC_ALLOWED_MODULES = new Set(['', 'home', 'chat', 'test', 'flashcards', 'progreso']);

const OPOSICION_BODY_ROUTES: Record<string, string> = {
  secretaria: '/app/oposiciones',
  c1: '/app/oposiciones-c1',
  c2: '/app/oposiciones-c2',
  ayudante_iipp: '/app/oposiciones-iipp',
  iipp: '/app/oposiciones-iipp',
  guardia_civil: '/app/guardia-civil',
  policia_nacional: '/app/policia-nacional',
  generico: '/app/base-comun',
};

export function isOposicionesBasicPlan(plan?: string | null): boolean {
  return plan === OPOSICIONES_BASIC_PLAN;
}

export function isMultiOposicionPlan(plan?: string | null): boolean {
  return plan === 'multi_oposicion' || plan === 'multi-oposicion';
}

export function canSwitchAllOposiciones(plan?: string | null): boolean {
  return isMultiOposicionPlan(plan);
}

export function getOposicionRouteForBody(body?: string | null): string {
  return OPOSICION_BODY_ROUTES[body || ''] || OPOSICION_BODY_ROUTES.secretaria;
}

export function isBasicOposicionesModuleAllowed(moduleId: string): boolean {
  return BASIC_ALLOWED_MODULES.has(moduleId);
}

export function getOposicionesModuleFromPath(pathname: string, basePath: string): string {
  const rest = pathname.slice(basePath.length).replace(/^\//, '');
  return rest.split('/')[0] || '';
}
